module.exports = __webpack_public_path__ + "static/media/about-awards.e76c884d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-awards.png
// module id = 1220
// module chunks = 0